import { createReducer } from '@reduxjs/toolkit';
import { parseCustomFields } from '@utils/functions.js';
import { DEFAULT_WEBHOOK_EVENTS } from '@views/AdminPanelView/components/AdminPanel/components/LinkInBio/components/Settings/components/Webhooks/utils/constants.js';

import * as settingsActions from './settingsActions.js';

const initialState = {
  // category: '',
  currency: '$',
  currencyCode: 'USD',
  stripeConnectPublic: {},
  facebookPixel: '',
  tikTokPixel: '',
  spreadSheetTitle: '',
  spreadSheetEmailTitle: '',
  spreadSheetFormTitle: '',
  isAirtable: false,
  airtableBaseId: '',
  airtableShopTable: '',
  airtableFormTable: '',
  airtableEmailTable: '',
  isNotion: false,
  notionParentPageId: '',
  notionShopDatabaseId: '',
  notionFormDatabaseId: '',
  notionEmailDatabaseId: '',
  directMessagePreset: `Hi! I'm interested in product [link]`,

  isAutoAction: false,
  paymentLink: '',
  isTelegram: false,
  isShowingNotifsTelegram: false,
  telegramChatObj: null,
  discordUser: '',
  isDiscordBotConnected: false,
  slackChannels: [],
  slackNotifsChannelId: null,
  isShowingNotifsSlack: false,
  langFields: '',

  isWebhook: false,
  webhookUrl: '',
  isWebhookLinkClick: false,
  isWebhookContactClick: false,
  isWebhookCartAdd: false,
  isWebhookEmailSubmit: false,
  isWebhookFormSubmit: false,
  isWebhookCartSubmit: false,
  isWebhookAppointmentSubmit: false,
  isWebhookDigitalSubmit: false,
  isWebhookDonationSubmit: false,
  isWebhookRequestSubmit: false,
  webhookEvents: { ...DEFAULT_WEBHOOK_EVENTS },

  isUTM: false,
  UTMMedium: '',
  UTMSource: '',
  isSEO: false,
  SEOTitle: '',
  SEODescription: '',
  SEOFavicon: '',
  SEOImage: '',
  SEOKeywords: '',
  sitemap: '',
  robots: '',
  isIndexable: false,

  paymentMenuType: '',
  walletType: '1',

  isStripe: false,
  isPayPal: false,
  isPaypalMe: false,
  isWayForPay: false,
  isFondy: false,
  isCashActive: false,
  isMonobank: false,

  fondyMerchantId: '',
  fondyPaymentKey: '',

  wayforpayMerchantLogin: '',
  wayforpayMerchantSecretKey: '',

  monobankToken: '',
  monobankConnect: {},

  payPalClientID: '',
  payPalClientSecret: '',

  payPalAccountType: '',
  payPalMeLink: '',
  paypalConnect: {},

  googleAnalytics: '',
  googleTag: '',

  isCustomDomain: false,
  customDomain: '',
  domainStatus: '',
  stripeConnect: null,

  isMailchimp: false,
  isGoogleSheet: false,
  replyApiKey: '',
  selzyApiKey: '',
  klaviyoApiKey: '',
  sendPulseAPI: '',
  sendPulseUser: null,
  sendPulseList: [],
  sendPulseEmailTitle: '',
  sendPulseFormTitle: '',
  sendPulseShopTitle: '',

  isShippingName: false,
  isShippingPhone: false,
  isShippingEmail: true,
  isShippingAddress: false,
  isShippingComment: false,
  isShippingNameRequired: false,
  isShippingPhoneRequired: false,
  isShippingEmailRequired: false,
  isShippingAddressRequired: false,
  isShippingCommentRequired: false,
  shippingFields: [],

  timeZone: '',
  pinterestTag: '',
  hotjarId: '',
  headTag: '',
  bodyTag: '',
  siteLimit: 1,

  sensitive: 'Off',

  propertiesList: [],
  lists: [],
  labels: [],
  categories: [],

  isSeoDefaultImage: false,
  seoDefaultImage: '',

  instagramBusinessUsers: [],

  preorderForm: {
    isComment: false,
    isCommentRequired: false,
    isEmail: true,
    isEmailRequired: true,
    isName: true,
    isNameRequired: true,
    isPhone: true,
    isPhoneRequired: true,
    isAddress: false,
    isAddressRequired: false,
    redirectUrl: '',
    resultText: '',
    submitButtonTitle: '',
  },

  nickname: '',
  bio: '',
  occupation: '',
  aiCategory: 'Local Business (local services)',
  location: '',
  instructions: '',
  aiLangCode: '',
};

const settings = createReducer(initialState, (builder) => {
  builder
    .addCase(settingsActions.settingsStore, (state, { payload: data }) => {
      const {
        // category,
        currency,
        currencyCode,
        stripeConnectPublic,
        facebookPixel,
        tikTokPixel,
        spreadSheetTitle,
        spreadSheetEmailTitle,
        spreadSheetFormTitle,
        isAirtable,
        airtableBaseId,
        airtableShopTable,
        airtableFormTable,
        airtableEmailTable,
        isNotion,
        notionParentPageId,
        notionShopDatabaseId,
        notionFormDatabaseId,
        notionEmailDatabaseId,
        directMessagePreset,
        isAutoAction,
        paymentLink,
        walletType,
        // isTelegram,
        telegramChatObj,
        discordUser,
        isDiscordBotConnected,
        langFields,

        isWebhook,
        isUTM,
        utmMedium,
        utmSource,
        isSEO,
        seoTitle,
        seoDescription,
        seoFavicon,
        seoCustomImage,
        seoKeywords,
        sitemap,
        robots,
        isIndexable,

        isStripe,
        isPaypal: isPayPal,
        isPaypalMe: isPayPalMe,
        isWayForPay,
        isFondy,
        isCashActive,
        isMonobank,

        fondyMerchantId,
        fondyPaymentKey,

        wayforpayMerchantLogin,
        wayforpayMerchantSecretKey,

        monobankToken,
        monobankConnect,

        paypalClientID: payPalClientID,
        paypalClientSecret: payPalClientSecret,

        paypalAccountType: payPalAccountType,
        paypalMeLink: payPalMeLink,
        paypalConnect,

        googleAnalytics,
        googleTagManagerID,

        isCustomDomain,
        customDomain,
        domainStatus,
        stripeConnect,
        // thumbnail,
        isMailchimp,
        isGoogleSheet,
        replyApiKey,
        selzyApiKey,
        klaviyoApiKey,
        sendPulseAPI,
        webhook,
        sendPulseUser,

        shipping,

        timeZone,
        pinterestTag,
        hotjarId,
        htmlHeadTag,
        htmlBodyTag,
        siteLimit,

        sensitive,
        shop,

        isSeoCustomImage,
        seoDefaultImage,

        instagramBusinessUsers,
      } = data;

      const aiAssistantBlock = data?.aiAssistant ?? data?.AiAssistant ?? data?.aiassistant;

      const aiAssistantName = data?.aiAssistantName ?? data?.AiAssistantName ?? aiAssistantBlock?.name ?? '';
      const aiAssistantBio = data?.aiAssistantBio ?? data?.AiAssistantBio ?? aiAssistantBlock?.bio ?? '';
      const aiAssistantOccupation = data?.aiAssistantOccupation ?? data?.AiAssistantOccupation ?? aiAssistantBlock?.occupation ?? '';
      const aiAssistantCategory = data?.aiAssistantCategory ?? data?.AiAssistantCategory ?? aiAssistantBlock?.category ?? '';
      const aiAssistantLocation = data?.aiAssistantLocation ?? data?.AiAssistantLocation ?? aiAssistantBlock?.location ?? '';
      const aiAssistantInstructions = data?.aiAssistantInstructions ?? data?.AiAssistantInstructions ?? aiAssistantBlock?.instructions ?? '';
      const aiAssistantLangCode = data?.aiAssistantLangCode ?? data?.AiAssistantLangCode ?? aiAssistantBlock?.langCode ?? '';

      let isTelegram;
      let isShowingNotifsTelegram = false;

      if (telegramChatObj) {
        isTelegram = true;
      } else {
        isTelegram = false;
        isShowingNotifsTelegram = false;
      }

      let webhookUrl = '';
      let isWebhookLinkClick = false;
      let isWebhookContactClick = false;
      let isWebhookCartAdd = false;
      let isWebhookEmailSubmit = false;
      let isWebhookFormSubmit = false;
      let isWebhookCartSubmit = false;
      let isWebhookAppointmentSubmit = false;
      let isWebhookDigitalSubmit = false;
      let isWebhookDonationSubmit = false;
      let isWebhookRequestSubmit = false;

      let webhookEvents = { ...DEFAULT_WEBHOOK_EVENTS };

      if (webhook) {
        const {
          isLinkClick,
          isContactClick,
          isCartAdd,
          isEmailSubmit,
          isFormSubmit,
          isCartSubmit,
          url,

          isAppointmentSubmit,
          isDigitalSubmit,
          isDonationSubmit,
          isRequestSubmit,
        } = webhook;

        webhookUrl = url ?? '';
        isWebhookLinkClick = isLinkClick ?? false;
        isWebhookContactClick = isContactClick ?? false;
        isWebhookCartAdd = isCartAdd ?? false;
        isWebhookEmailSubmit = isEmailSubmit ?? false;
        isWebhookFormSubmit = isFormSubmit ?? false;
        isWebhookCartSubmit = isCartSubmit ?? false;
        isWebhookAppointmentSubmit = isAppointmentSubmit ?? false;
        isWebhookDigitalSubmit = isDigitalSubmit ?? false;
        isWebhookDonationSubmit = isDonationSubmit ?? false;
        isWebhookRequestSubmit = isRequestSubmit ?? false;

        // Populate webhookEvents from API response
        Object.keys(DEFAULT_WEBHOOK_EVENTS).forEach((key) => {
          webhookEvents[key] = webhook[key] ?? false;
        });
      }

      return {
        ...state,

        nickname: aiAssistantName ?? state.nickname ?? '',
        bio: aiAssistantBio ?? state.bio ?? '',
        occupation: aiAssistantOccupation ?? state.occupation ?? '',
        aiCategory: aiAssistantCategory ?? state.aiCategory ?? 'Local Business (local services)',
        location: aiAssistantLocation ?? state.location ?? '',
        instructions: aiAssistantInstructions ?? state.instructions ?? '',
        aiLangCode: aiAssistantLangCode ?? state.aiLangCode ?? '',

        // category: category ?? '',
        currency: currency ?? '$',
        currencyCode: currencyCode ?? 'USD',
        stripeConnectPublic: stripeConnectPublic ?? {},
        facebookPixel: facebookPixel ?? '',
        tikTokPixel: tikTokPixel ?? '',
        spreadSheetTitle: spreadSheetTitle ?? '',
        spreadSheetEmailTitle: spreadSheetEmailTitle ?? '',
        spreadSheetFormTitle: spreadSheetFormTitle ?? '',
        isAirtable: isAirtable ?? false,
        airtableBaseId: airtableBaseId ?? '',
        airtableShopTable: airtableShopTable ?? '',
        airtableFormTable: airtableFormTable ?? '',
        airtableEmailTable: airtableEmailTable ?? '',
        isNotion: isNotion ?? false,
        notionParentPageId: notionParentPageId ?? '',
        notionShopDatabaseId: notionShopDatabaseId ?? '',
        notionFormDatabaseId: notionFormDatabaseId ?? '',
        notionEmailDatabaseId: notionEmailDatabaseId ?? '',
        directMessagePreset: directMessagePreset ?? `Hi! I'm interested in product [link]`,

        isAutoAction: isAutoAction ?? false,
        paymentLink: paymentLink ?? '',
        walletType: walletType ?? 'unilink',

        isTelegram,
        isShowingNotifsTelegram,
        telegramChatObj,
        discordUser,
        isDiscordBotConnected,

        langFields: langFields ?? state.langFields ?? '',

        isWebhook: isWebhook ?? false,
        webhookUrl,
        isWebhookLinkClick,
        isWebhookContactClick,
        isWebhookCartAdd,
        isWebhookEmailSubmit,
        isWebhookFormSubmit,
        isWebhookCartSubmit,
        isWebhookAppointmentSubmit,
        isWebhookDigitalSubmit,
        isWebhookDonationSubmit,
        isWebhookRequestSubmit,
        webhookEvents,

        isUTM: isUTM ?? false,
        utmMedium: utmMedium ?? '',
        utmSource: utmSource ?? '',
        IsSEO: isSEO ?? false,
        SEOTitle: seoTitle ?? 'Your SEO Title',
        SEODescription: seoDescription ?? 'Your SEO Description',
        SEOFavicon: seoFavicon ?? '',
        SEOImage: seoCustomImage ?? '',
        seoKeywords: seoKeywords ?? '',
        sitemap: sitemap ?? '',
        robots: robots ?? '',
        isIndexable: isIndexable ?? false,

        isStripe: isStripe ?? false,
        isPayPal: isPayPal ?? false,
        isPayPalMe: isPayPalMe ?? false,
        isWayForPay: isWayForPay ?? false,
        isFondy: isFondy ?? false,
        isCashActive: isCashActive ?? false,
        isMonobank: isMonobank ?? false,

        fondyMerchantId: fondyMerchantId ?? '',
        fondyPaymentKey: fondyPaymentKey ?? '',

        wayforpayMerchantLogin: wayforpayMerchantLogin ?? '',
        wayforpayMerchantSecretKey: wayforpayMerchantSecretKey ?? '',

        monobankToken: monobankToken ?? '',
        monobankConnect: monobankConnect ?? {},

        payPalClientID: payPalClientID ?? '',
        payPalClientSecret: payPalClientSecret ?? '',

        payPalAccountType: payPalAccountType ?? '',
        payPalMeLink: payPalMeLink ?? '',
        paypalConnect: paypalConnect ?? {},

        googleAnalytics: googleAnalytics ?? '',
        googleTag: googleTagManagerID ?? '',

        isCustomDomain: isCustomDomain ?? false,
        customDomain: customDomain ?? '',
        domainStatus: domainStatus ?? '',
        stripeConnect: stripeConnect ?? null,

        isMailchimp: isMailchimp ?? false,
        isGoogleSheet: isGoogleSheet ?? false,
        replyApiKey: replyApiKey ?? '',
        selzyApiKey: selzyApiKey ?? '',
        klaviyoApiKey: klaviyoApiKey ?? '',
        sendPulseAPI: sendPulseAPI ?? '',
        sendPulseUser: sendPulseUser ?? null,
        sendPulseEmailTitle: sendPulseUser?.EmailList ?? 'Select list',
        sendPulseFormTitle: sendPulseUser?.FormList ?? 'Select list',
        sendPulseShopTitle: sendPulseUser?.ShopList ?? 'Select list',

        isShippingName: shipping?.isShippingName ?? false,
        isShippingPhone: shipping?.isShippingPhone ?? false,
        isShippingEmail: shipping?.isShippingEmail ?? true,
        isShippingAddress: shipping?.isShippingAddress ?? false,
        isShippingComment: shipping?.isShippingComment ?? false,
        isShippingNameRequired: shipping?.isShippingAddressRequired ?? false,
        isShippingPhoneRequired: shipping?.isShippingPhoneRequired ?? false,
        isShippingEmailRequired: shipping?.isShippingEmailRequired ?? false,
        isShippingAddressRequired: shipping?.isShippingNameRequired ?? false,
        isShippingCommentRequired: shipping?.isShippingCommentRequired ?? false,
        shippingFields: parseCustomFields(shipping?.shippingFields) ?? [],

        timeZone: timeZone ?? '',
        pinterestTag: pinterestTag ?? '',
        hotjarId: hotjarId ?? '',
        headTag: htmlHeadTag ?? '',
        bodyTag: htmlBodyTag ?? '',
        siteLimit: siteLimit ?? 1,

        sensitive: sensitive ?? 'Off',

        propertiesList: shop?.propertiesList ?? [],
        lists: shop?.lists ?? [],
        labels: shop?.labels ?? [],
        categories: shop?.categories ?? [],
        preorderForm: shop?.preorderForm,

        isSeoDefaultImage: isSeoCustomImage ?? false,
        seoDefaultImage: seoDefaultImage ?? '',
        instagramBusinessUsers: instagramBusinessUsers ?? [],
      };
    })

    .addCase(settingsActions.settingsClear, () => ({ ...initialState }))

    .addCase(settingsActions.settingsUpdateSensitiveContent, (state, { payload: sensitive }) => ({ ...state, sensitive }))

    .addCase(settingsActions.settingsUpdateCurrency, (state, { payload: currency }) => ({ ...state, currency }))
    // .addCase(settingsActions.settingsUpdateCategory, (state, { payload: category }) => ({ ...state, category }))
    .addCase(settingsActions.settingsUpdateCurrencyCode, (state, { payload: currencyCode }) => ({ ...state, currencyCode }))
    .addCase(settingsActions.settingsUpdateStripeConnectPublic, (state, { payload: stripeConnectPublic }) => ({ ...state, stripeConnectPublic }))
    .addCase(settingsActions.settingsUpdateFacebookPixel, (state, { payload: facebookPixel }) => ({ ...state, facebookPixel }))
    .addCase(settingsActions.settingsUpdateTikTokPixel, (state, { payload: tikTokPixel }) => ({ ...state, tikTokPixel }))
    .addCase(settingsActions.settingsUpdateSpreadSheetTitle, (state, { payload: spreadSheetTitle }) => ({ ...state, spreadSheetTitle }))
    .addCase(settingsActions.settingsUpdateSpreadSheetEmailTitle, (state, { payload: spreadSheetEmailTitle }) => ({ ...state, spreadSheetEmailTitle }))
    .addCase(settingsActions.settingsUpdateSpreadSheetFormTitle, (state, { payload: spreadSheetFormTitle }) => ({ ...state, spreadSheetFormTitle }))
    .addCase(settingsActions.settingsUpdateIsAirtable, (state, { payload: isAirtable }) => ({ ...state, isAirtable }))
    .addCase(settingsActions.settingsUpdateAirtableBaseId, (state, { payload: airtableBaseId }) => ({ ...state, airtableBaseId }))
    .addCase(settingsActions.settingsUpdateAirtableShopTable, (state, { payload: airtableShopTable }) => ({ ...state, airtableShopTable }))
    .addCase(settingsActions.settingsUpdateIsNotion, (state, { payload: isNotion }) => ({ ...state, isNotion }))
    .addCase(settingsActions.settingsUpdateNotionParentPageId, (state, { payload: notionParentPageId }) => ({ ...state, notionParentPageId }))
    .addCase(settingsActions.settingsUpdateNotionShopDatabaseId, (state, { payload: notionShopDatabaseId }) => ({ ...state, notionShopDatabaseId }))
    .addCase(settingsActions.settingsUpdateDirectMessagePreset, (state, { payload: directMessagePreset }) => ({ ...state, directMessagePreset }))

    .addCase(settingsActions.settingsUpdateIsAutoAction, (state, { payload: isAutoAction }) => ({ ...state, isAutoAction }))
    .addCase(settingsActions.settingsUpdatePaymentLink, (state, { payload: paymentLink }) => ({ ...state, paymentLink }))
    .addCase(settingsActions.settingsUpdateWalletType, (state, { payload: walletType }) => ({ ...state, walletType }))

    .addCase(settingsActions.settingsUpdateIsTelegram, (state, { payload: isTelegram }) => ({ ...state, isTelegram }))
    .addCase(settingsActions.settingsUpdateIsShowingNotifsTelegram, (state, { payload: isShowingNotifsTelegram }) => ({ ...state, isShowingNotifsTelegram }))
    .addCase(settingsActions.settingsUpdateTelegramChatObj, (state, { payload: telegramChatObj }) => ({ ...state, telegramChatObj }))
    .addCase(settingsActions.settingsUpdateDiscordUser, (state, { payload: discordUser }) => ({ ...state, discordUser }))
    .addCase(settingsActions.settingsUpdateIsDiscordBotConnected, (state, { payload: isDiscordBotConnected }) => ({ ...state, isDiscordBotConnected }))
    .addCase(settingsActions.settingsUpdateSlackChannels, (state, { payload: slackChannels }) => ({ ...state, slackChannels: slackChannels || [] }))
    .addCase(settingsActions.settingsUpdateSlackNotifsChannelId, (state, { payload: slackNotifsChannelId }) => ({ ...state, slackNotifsChannelId }))
    .addCase(settingsActions.settingsUpdateIsShowingNotifsSlack, (state, { payload: isShowingNotifsSlack }) => ({ ...state, isShowingNotifsSlack }))
    .addCase(settingsActions.settingsUpdateLangFields, (state, { payload: langFields }) => ({ ...state, langFields }))

    .addCase(settingsActions.settingsUpdateIsWebhook, (state, { payload: isWebhook }) => ({ ...state, isWebhook }))
    .addCase(settingsActions.settingsUpdateWebhookUrl, (state, { payload: webhookUrl }) => ({ ...state, webhookUrl }))
    .addCase(settingsActions.settingsUpdateIsWebhookLinkClick, (state, { payload: isWebhookLinkClick }) => ({ ...state, isWebhookLinkClick }))
    .addCase(settingsActions.settingsUpdateIsWebhookContactClick, (state, { payload: isWebhookContactClick }) => ({ ...state, isWebhookContactClick }))
    .addCase(settingsActions.settingsUpdateIsWebhookCartAdd, (state, { payload: isWebhookCartAdd }) => ({ ...state, isWebhookCartAdd }))
    .addCase(settingsActions.settingsUpdateIsWebhookEmailSubmit, (state, { payload: isWebhookEmailSubmit }) => ({ ...state, isWebhookEmailSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookFormSubmit, (state, { payload: isWebhookFormSubmit }) => ({ ...state, isWebhookFormSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookCartSubmit, (state, { payload: isWebhookCartSubmit }) => ({ ...state, isWebhookCartSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookAppointmentSubmit, (state, { payload: isWebhookAppointmentSubmit }) => ({ ...state, isWebhookAppointmentSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookDigitalSubmit, (state, { payload: isWebhookDigitalSubmit }) => ({ ...state, isWebhookDigitalSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookDonationSubmit, (state, { payload: isWebhookDonationSubmit }) => ({ ...state, isWebhookDonationSubmit }))
    .addCase(settingsActions.settingsUpdateIsWebhookRequestSubmit, (state, { payload: isWebhookRequestSubmit }) => ({ ...state, isWebhookRequestSubmit }))
    .addCase(settingsActions.settingsUpdateWebhookEvents, (state, { payload: webhookEvents }) => ({ ...state, webhookEvents }))
    .addCase(settingsActions.settingsUpdateWebhookEvent, (state, { payload: { key, value } }) => ({
      ...state,
      webhookEvents: { ...state.webhookEvents, [key]: value },
    }))

    .addCase(settingsActions.settingsUpdateIsUTM, (state, { payload: isUTM }) => ({ ...state, isUTM }))
    .addCase(settingsActions.settingsUpdateUTMMedium, (state, { payload: UTMMedium }) => ({ ...state, UTMMedium }))
    .addCase(settingsActions.settingsUpdateUTMSource, (state, { payload: UTMSource }) => ({ ...state, UTMSource }))
    .addCase(settingsActions.settingsUpdateIsSEO, (state, { payload: IsSEO }) => ({ ...state, IsSEO }))
    .addCase(settingsActions.settingsUpdateSEOTitle, (state, { payload: SEOTitle }) => ({ ...state, SEOTitle }))
    .addCase(settingsActions.settingsUpdateSEODescription, (state, { payload: SEODescription }) => ({ ...state, SEODescription }))
    .addCase(settingsActions.settingsUpdateSEOFavicon, (state, { payload: SEOFavicon }) => ({ ...state, SEOFavicon }))
    .addCase(settingsActions.settingsUpdateSEOImage, (state, { payload: SEOImage }) => ({ ...state, SEOImage }))
    .addCase(settingsActions.settingsUpdateSEOKeywords, (state, { payload: SEOKeywords }) => ({ ...state, SEOKeywords }))
    .addCase(settingsActions.settingsUpdateSitemap, (state, { payload: sitemap }) => ({ ...state, sitemap }))
    .addCase(settingsActions.settingsUpdateRobots, (state, { payload: robots }) => ({ ...state, robots }))
    .addCase(settingsActions.settingsUpdateIsIndexable, (state, { payload: isIndexable }) => ({ ...state, isIndexable }))

    .addCase(settingsActions.settingsUpdatePaymentMenuType, (state, { payload: paymentMenuType }) => ({ ...state, paymentMenuType }))

    .addCase(settingsActions.settingsUpdateIsStripe, (state, { payload: isStripe }) => ({ ...state, isStripe }))
    .addCase(settingsActions.settingsUpdateIsPayPal, (state, { payload: isPayPaly }) => ({ ...state, isPayPaly }))
    .addCase(settingsActions.settingsUpdateIsPayPalMe, (state, { payload: isPayPalMe }) => ({ ...state, isPayPalMe }))
    .addCase(settingsActions.settingsUpdateIsWayForPay, (state, { payload: isWayForPay }) => ({ ...state, isWayForPay }))
    .addCase(settingsActions.settingsUpdateIsFondy, (state, { payload: isFondy }) => ({ ...state, isFondy }))
    .addCase(settingsActions.settingsUpdateIsCashActive, (state, { payload: isCashActive }) => ({ ...state, isCashActive }))
    .addCase(settingsActions.settingsUpdateIsMonobank, (state, { payload: isMonobank }) => ({ ...state, isMonobank }))

    .addCase(settingsActions.settingsUpdateFondyMerchantId, (state, { payload: fondyMerchantId }) => ({ ...state, fondyMerchantId }))
    .addCase(settingsActions.settingsUpdateFondyPaymentKey, (state, { payload: fondyPaymentKey }) => ({ ...state, fondyPaymentKey }))

    .addCase(settingsActions.settingsUpdateWayforpayMerchantLogin, (state, { payload: wayforpayMerchantLogin }) => ({ ...state, wayforpayMerchantLogin }))
    .addCase(settingsActions.settingsUpdateWayforpayMerchantSecretKey, (state, { payload: wayforpayMerchantSecretKey }) => ({ ...state, wayforpayMerchantSecretKey }))

    .addCase(settingsActions.settingsUpdateMonobankToken, (state, { payload: monobankToken }) => ({ ...state, monobankToken }))
    .addCase(settingsActions.settingsUpdateMonobankConnect, (state, { payload: monobankConnect }) => ({ ...state, monobankConnect }))

    .addCase(settingsActions.settingsUpdatePayPalClientID, (state, { payload: payPalClientID }) => ({ ...state, payPalClientID }))
    .addCase(settingsActions.settingsUpdatePayPalClientSecret, (state, { payload: payPalClientSecret }) => ({ ...state, payPalClientSecret }))
    .addCase(settingsActions.settingsUpdatePayPalAccountType, (state, { payload: payPalAccountType }) => ({ ...state, payPalAccountType }))
    .addCase(settingsActions.settingsUpdatePayPalMeLink, (state, { payload: payPalMeLink }) => ({ ...state, payPalMeLink }))
    .addCase(settingsActions.settingsUpdatePayPalConnect, (state, { payload: paypalConnect }) => ({ ...state, paypalConnect }))

    .addCase(settingsActions.settingsUpdateGoogleAnalytics, (state, { payload: googleAnalytics }) => ({ ...state, googleAnalytics }))
    .addCase(settingsActions.settingsUpdateGoogleTag, (state, { payload: googleTag }) => ({ ...state, googleTag }))

    .addCase(settingsActions.settingsUpdateIsCustomDomain, (state, { payload: isCustomDomain }) => ({ ...state, isCustomDomain }))
    .addCase(settingsActions.settingsUpdateCustomDomain, (state, { payload: customDomain }) => ({ ...state, customDomain }))
    .addCase(settingsActions.settingsUpdateDomainStatus, (state, { payload: domainStatus }) => ({ ...state, domainStatus }))
    .addCase(settingsActions.settingsUpdateStripeConnect, (state, { payload: StripeConnect }) => ({ ...state, StripeConnect }))

    .addCase(settingsActions.settingsUpdateIsMailchimp, (state, { payload: isMailchimp }) => ({ ...state, isMailchimp }))
    .addCase(settingsActions.settingsUpdateIsGoogleSheet, (state, { payload: isGoogleSheet }) => ({ ...state, isGoogleSheet }))
    .addCase(settingsActions.settingsUpdateReplyAPI, (state, { payload: replyApiKey }) => ({ ...state, replyApiKey }))
    .addCase(settingsActions.settingsUpdateSelzyAPI, (state, { payload: selzyApiKey }) => ({ ...state, selzyApiKey }))
    .addCase(settingsActions.settingsUpdateKlaviyouAPI, (state, { payload: klaviyoApiKey }) => ({ ...state, klaviyoApiKey }))
    .addCase(settingsActions.settingsUpdateSendPulseAPI, (state, { payload: sendPulseAPI }) => ({ ...state, sendPulseAPI }))
    .addCase(settingsActions.settingsUpdateSendPulseUser, (state, { payload: sendPulseUser }) => ({ ...state, sendPulseUser }))
    .addCase(settingsActions.settingsUpdateSendPulseList, (state, { payload: sendPulseList }) => ({ ...state, sendPulseList }))
    .addCase(settingsActions.settingsUpdateSendPulseEmailTitle, (state, { payload: sendPulseEmailTitle }) => ({ ...state, sendPulseEmailTitle }))
    .addCase(settingsActions.settingsUpdateSendPulseFormTitle, (state, { payload: sendPulseFormTitle }) => ({ ...state, sendPulseFormTitle }))
    .addCase(settingsActions.settingsUpdateSendPulseShopTitle, (state, { payload: sendPulseShopTitle }) => ({ ...state, sendPulseShopTitle }))

    .addCase(settingsActions.settingsUpdateIsShippingName, (state, { payload: isShippingName }) => ({ ...state, isShippingName }))
    .addCase(settingsActions.settingsUpdateIsShippingPhone, (state, { payload: isShippingPhone }) => ({ ...state, isShippingPhone }))
    .addCase(settingsActions.settingsUpdateIsShippingEmail, (state, { payload: isShippingEmail }) => ({ ...state, isShippingEmail }))
    .addCase(settingsActions.settingsUpdateIsShippingAddress, (state, { payload: isShippingAddress }) => ({ ...state, isShippingAddress }))
    .addCase(settingsActions.settingsUpdateIsShippingComment, (state, { payload: isShippingComment }) => ({ ...state, isShippingComment }))
    .addCase(settingsActions.settingsUpdateIsShippingNameRequired, (state, { payload: isShippingNameRequired }) => ({ ...state, isShippingNameRequired }))
    .addCase(settingsActions.settingsUpdateIsShippingPhoneRequired, (state, { payload: isShippingPhoneRequired }) => ({ ...state, isShippingPhoneRequired }))
    .addCase(settingsActions.settingsUpdateIsShippingEmailRequired, (state, { payload: isShippingEmailRequired }) => ({ ...state, isShippingEmailRequired }))
    .addCase(settingsActions.settingsUpdateIsShippingAddressRequired, (state, { payload: isShippingAddressRequired }) => ({ ...state, isShippingAddressRequired }))
    .addCase(settingsActions.settingsUpdateIsShippingCommentRequired, (state, { payload: isShippingCommentRequired }) => ({ ...state, isShippingCommentRequired }))
    .addCase(settingsActions.settingsUpdateShippingFields, (state, { payload: shippingFields }) => ({ ...state, shippingFields }))

    .addCase(settingsActions.settingsUpdateTimeZone, (state, { payload: timeZone }) => ({ ...state, timeZone }))
    .addCase(settingsActions.settingsUpdatePinterestTag, (state, { payload: pinterestTag }) => ({ ...state, pinterestTag }))
    .addCase(settingsActions.settingsUpdateHotjarId, (state, { payload: hotjarId }) => ({ ...state, hotjarId }))
    .addCase(settingsActions.settingsUpdateHeadTag, (state, { payload: headTag }) => ({ ...state, headTag }))
    .addCase(settingsActions.settingsUpdateBodyTag, (state, { payload: bodyTag }) => ({ ...state, bodyTag }))
    .addCase(settingsActions.settingsUpdateSiteLimit, (state, { payload: siteLimit }) => ({ ...state, siteLimit }))

    .addCase(settingsActions.settingsUpdatePropertiesList, (state, { payload: propertiesList }) => ({ ...state, propertiesList }))
    .addCase(settingsActions.settingsUpdateLists, (state, { payload: lists }) => ({ ...state, lists }))
    .addCase(settingsActions.settingsUpdateLabels, (state, { payload: labels }) => ({ ...state, labels }))
    .addCase(settingsActions.settingsUpdateCategories, (state, { payload: categories }) => ({ ...state, categories }))

    .addCase(settingsActions.settingsUpdateIsSeoDefaultImage, (state, { payload: isSeoDefaultImage }) => ({ ...state, isSeoDefaultImage }))
    .addCase(settingsActions.settingsUpdateSeoDefaultImage, (state, { payload: seoDefaultImage }) => ({ ...state, seoDefaultImage }))

    .addCase(settingsActions.settingsUpdateInstagramBusinessUsers, (state, { payload: instagramBusinessUsers }) => ({ ...state, instagramBusinessUsers }))

    .addCase(settingsActions.settingsUpdatePreorderForm, (state, { payload: preorderForm }) => ({ ...state, preorderForm }))

    .addCase(settingsActions.settingsUpdateAiAssistantNickname, (state, { payload: nickname }) => ({ ...state, nickname }))
    .addCase(settingsActions.settingsUpdateAiAssistantBio, (state, { payload: bio }) => ({ ...state, bio }))
    .addCase(settingsActions.settingsUpdateAiAssistantOccupation, (state, { payload: occupation }) => ({ ...state, occupation }))
    .addCase(settingsActions.settingsUpdateAiAssistantLocation, (state, { payload: location }) => ({ ...state, location }))
    .addCase(settingsActions.settingsUpdateAiAssistantInstructions, (state, { payload: instructions }) => ({ ...state, instructions }))
    .addCase(settingsActions.settingsUpdateAiAssistantCategory, (state, { payload: aiCategory }) => ({ ...state, aiCategory }))
    .addCase(settingsActions.settingsUpdateAiAssistantLangCode, (state, { payload: aiLangCode }) => ({ ...state, aiLangCode }));
});

export default settings;
